import { gql } from '@apollo/client';
import operationResultFragment from '../../../shared/queries/operationResultFragment';

const CHANGE_USER_FREE_STATUS = gql`
  mutation ChangeUserFreeStatus($moveLicenseType: Int!, $externalUserId: Int!, $systemRoleId: Int) {
    changeUserFreeStatus(
      moveLicenseType: $moveLicenseType
      externalUserId: $externalUserId
      systemRoleId: $systemRoleId
    ) {
      ...OperationResultFields
    }
  }
  ${operationResultFragment}
`;

export default CHANGE_USER_FREE_STATUS;
